// extracted by mini-css-extract-plugin
export default {"ChartSettingContainer":"styles_ChartSettingContainer__WTg-1","small":"styles_small__-OYgo","active":"styles_active__xrU3Q"};